/**
 * toggles a target's css "active" class
 * by clicking on its toggle btn
 * */
export default class AbstractWidgetToggler {
  /**
   * @param {HTMLButtonElement} btn
   * @param {HTMLElement} target
   * @param {activeClass} string
   * */
  constructor({ btn, target, activeClass = "is-active", callback }) {
    this.btn = btn;
    this.target = target;
    this.activeClass = activeClass;
    this.isActive = false;
    this.callback = callback;
  }

  init() {
    this.btn?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      this.isActive
        ? this.close()
        : this.open();
    });

    this.target?.addEventListener(
      "click",
      (e) => e.stopPropagation() 
    );
  }

  open() {
    if (this.isActive) {
      return;
    }

    this.target?.classList.add(this.activeClass);
    this.isActive = true;

    this.callback?.call(null, { type: "widgetopen", widget: this });
  }

  close() {
    if (!this.isActive) {
      return;
    }

    this.target?.classList.remove(this.activeClass);
    this.isActive = false;
    this.callback?.call(null, { type: "widgetclose", widget: this });
  }
}